import StandEditForm from "./stand-edit-form";

export default StandEditForm;